/* eslint-disable camelcase */
// import { isEmpty } from 'lodash';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  AwardAgreementDocumentImportService,
  Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto,
} from '../../services/wealthlane-award-services';

const usePostAwardAgreementDocument = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      const newPayload = {
        File: payload.file,
        ZipFile: payload.zipFile,
      };

      return await handleRequest(
        AwardAgreementDocumentImportService.postApiAwardApiAppAwardAgreementDocumentImportImportAwardAgreementDocument(
          newPayload
        )
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          await queryClient.invalidateQueries('getParticipantBroadcastMessageList');
          closeModal();
          toast.success(
            <ToastComponent label='Success' message={`Award Agreement import job submitted.`} />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostAwardAgreementDocument;
